import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';

export default function DemographicPartnerForm({ formData, setFormData, formErrors, showFormErrors}) {
  const handleChange = e => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  return (
    <div className="demographic-partner-form">
      <h2 className="mb-4">Partner Information</h2>

      <Row className="mb-3">
        <Col>
          <Form.Group controlId="partnerFirstName">
            <Form.Label className="required">Partner's First Name</Form.Label>
            <Form.Control type="text" name="partner_name_first" maxLength={20} required value={formData.partner_name_first} onChange={handleChange} />
          </Form.Group>
        </Col>
        <Col>
          <Form.Group controlId="partnerLastName">
            <Form.Label className="required">Partner's Last Name</Form.Label>
            <Form.Control type="text" name="partner_name_last" maxLength={20} required value={formData.partner_name_last} onChange={handleChange} />
          </Form.Group>
        </Col>
      </Row>

      <Form.Group controlId="partnerChosenName" className="mb-3">
        <Form.Label>Partner’s Chosen Name</Form.Label>
        <Form.Control type="text" name="partners_chosen_name" value={formData.partners_chosen_name} onChange={handleChange} />
      </Form.Group>

      <Form.Group controlId="partnerDob" className="mb-3">
        <Form.Label className="required">Partner's Date of Birth</Form.Label>
        <Form.Control type="date" name="partners_date_of_birth" required value={formData.partners_date_of_birth} onChange={handleChange} />
      </Form.Group>

      <Form.Group controlId="partnerEmail" className="mb-3">
        <Form.Label className="required">Partner's Email</Form.Label>
        <Form.Control type="email" name="partners_email" required value={formData.partners_email} onChange={handleChange} isInvalid={ showFormErrors && !formData?.partners_email?.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)}/>
      </Form.Group>

      <Form.Group controlId="partnerSexAssigned" className="mb-3">
        <Form.Label className="required">Partner’s Sex Assigned at Birth</Form.Label>
        <Form.Select name="partners_sex_assigned_at_birth" required value={formData.partners_sex_assigned_at_birth} onChange={handleChange}>
          <option value="">Select...</option>
          <option value="Female">Female</option>
          <option value="Male">Male</option>
          <option value="Other">Other</option>
        </Form.Select>
      </Form.Group>

      <Form.Group controlId="partnerGenderIdentity" className="mb-3">
        <Form.Label className="required">Partner's Gender Identity</Form.Label>
        <Form.Select name="partners_current_gender_identity" required value={formData.partners_current_gender_identity} onChange={handleChange}>
          <option value="">Select...</option>
          <option value="Woman">Woman</option>
          <option value="Trans Woman">Trans Woman</option>
          <option value="Man">Man</option>
          <option value="Trans Man">Trans Man</option>
          <option value="Non-binary">Non-binary</option>
          <option value="Not listed or prefer not to say">Not listed or prefer not to say</option>
        </Form.Select>
      </Form.Group>

      <Form.Group as={Row} className="mb-3">
        <Form.Label className="required" as="legend" column sm={12}>
          Does your partner currently have an Ontario Health Insurance Plan (OHIP) card?
        </Form.Label>
        <Col sm={10}>
          <Form.Check id={'partner_valid_ohip-yes'} type="radio" label="Yes" name="partner_valid_ohip" value="Yes" checked={formData.partner_valid_ohip === 'Yes'} onChange={handleChange} required />
          <Form.Check id={'partner_valid_ohip-no'} type="radio" label="No" name="partner_valid_ohip" value="No" checked={formData.partner_valid_ohip === 'No'} onChange={handleChange} required />
        </Col>
      </Form.Group>
    </div>
  );
}
